exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/***** About us *****/\n.about-us-container {\n  padding-bottom: 65px; }\n\n.jumbotron {\n  margin-top: 10px; }\n\n.about-us-box {\n  padding-top: 30px;\n  padding-bottom: 15px; }\n\n.about-us-box .about-us-photo {\n  position: relative;\n  width: 160px;\n  margin: 0 auto; }\n\n.lead {\n  font-size: 16px; }\n\n.about-us-box .about-us-photo img {\n  border-radius: 4px;\n  height: 150px; }\n\n.about-us-box .about-us-photo .about-us-role {\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  padding: 3px 5px;\n  background: #42bfc2;\n  font-size: 14px;\n  color: #fff;\n  line-height: 15px;\n  text-transform: uppercase; }\n\n.about-us-box .about-us-social {\n  margin-top: 5px;\n  font-size: 36px;\n  line-height: 36px; }\n\n.about-us-box .about-us-social a {\n  color: #444343; }\n\n.about-us-box .about-us-social a:hover, .about-us-box .about-us-social a:focus {\n  color: #42bfc2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/aboutus/aboutus.component.scss
// module id = ../../../../../src/app/aboutus/aboutus.component.scss
// module chunks = main